import MenuForm from '../../components/Menu/MenuForm'

export default function MenuCreate() {
  return <MenuForm />
}
